// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"11fcede2","237":"672fb790","638":"80a5f967","751":"8c7f8b81","771":"f8c9be5a","881":"41c3f5d9"}[chunkId] + ".chunk.js";
};